import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Sparkle, ArrowRight, LockSimple } from "@phosphor-icons/react";

const SEEN_KEY = "claro_whatsnew_seen";

export default function WhatsNew() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [unseen, setUnseen] = useState(false);

  useEffect(() => {
    api.get("/whats-new").then(({ data }) => {
      setData(data);
      const seen = localStorage.getItem(SEEN_KEY);
      if (data.latest_date && seen !== data.latest_date) setUnseen(true);
    }).catch(() => {});
  }, []);

  const openPanel = () => {
    setOpen(true);
    if (data?.latest_date) { localStorage.setItem(SEEN_KEY, data.latest_date); setUnseen(false); }
  };

  if (!data || !data.items?.length) return null;
  const mine = data.items.filter((i) => i.available);
  const upgrade = data.items.filter((i) => !i.available);

  return (
    <>
      <button onClick={openPanel} data-testid="whats-new-btn"
        className="relative inline-flex items-center gap-2 border border-primary/40 bg-primary/5 text-primary px-3 py-1.5 text-sm font-semibold hover:bg-primary/10 transition-colors">
        <Sparkle size={16} weight="fill" /> What's New
        {unseen && <span className="absolute -top-1.5 -right-1.5 h-3 w-3 rounded-full bg-red-500 border-2 border-white" data-testid="whats-new-badge" />}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-none max-w-lg max-h-[85vh] overflow-y-auto" data-testid="whats-new-dialog">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><Sparkle size={18} weight="fill" className="text-primary" /> What's New in ClaroShield</DialogTitle></DialogHeader>

          {mine.length > 0 && (
            <div className="space-y-2">
              <div className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">New for you</div>
              {mine.map((i) => (
                <div key={i.id} className="border border-border p-3" data-testid={`whats-new-item-${i.id}`}>
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-sm">{i.title}</span>
                    <span className="text-[11px] text-muted-foreground">{i.date}</span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{i.blurb}</p>
                  <button onClick={() => { setOpen(false); nav("/guide"); }} data-testid={`whats-new-manual-${i.id}`}
                    className="inline-flex items-center gap-1 text-xs text-primary font-medium mt-2 hover:underline">
                    Read in your manual <ArrowRight size={12} />
                  </button>
                </div>
              ))}
            </div>
          )}

          {upgrade.length > 0 && (
            <div className="space-y-2 mt-3">
              <div className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Available when you upgrade</div>
              {upgrade.map((i) => (
                <div key={i.id} className="border border-dashed border-border p-3 opacity-70" data-testid={`whats-new-upgrade-${i.id}`}>
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-sm flex items-center gap-1.5"><LockSimple size={13} /> {i.title}</span>
                    <Badge variant="outline" className="rounded-none text-[10px]">Upgrade</Badge>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{i.blurb}</p>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
